// Copyright (c) 2019-present Ladifire, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import React from 'react';
import classNames from 'classnames';

import {gridSize} from '@lfbuilder-ui/theme/constants';

import {ButtonAppearances, Spacing} from './types';

import styles from '../../styles/components/button/style.scss';

export type ButtonGroupLayout =
    | 'horizontal'
    | 'vertical';

export type ButtonGroupProps = {
    appearance?: ButtonAppearances;

    /** This group has only icon buttons */
    onlyIcon?: boolean;

    /** Set spacing for all buttons in group */
    isTransparent?: boolean;

    /** Set if the button group is disabled */
    isDisabled?: boolean;

    /** Set spacing for all buttons in group */
    spacing?: Spacing;

    /** Set layout for button group */
    layout?: ButtonGroupLayout;

    /** Set if show the separator at the end of group */
    showSeparator?: boolean;
};

export const groupItemStyles = {
    flex: '1 0 auto',
    display: 'flex',

    /* margins don't flip when the layout uses dir="rtl", whereas pseudos do */
    '& + &::before': {
        content: '""',
        display: 'inline-block',
        width: '4px',
    },
};

export default class ButtonGroup extends React.Component<ButtonGroupProps> {
    static defaultProps = {
        appearance: 'default',
        spacing: 'default',
        onlyIcon: true,
        isTransparent: true,
        isDisabled: false,
        layout: 'horizontal',
        showSeparator: false,
    };

    render() {
        const {
            appearance,
            children,
            onlyIcon,
            spacing,
            isTransparent,
            isDisabled,
            layout,
            showSeparator,
        } = this.props;

        return (
            <div
                style={{
                    display: 'inline-flex',
                    flexDirection: layout === 'horizontal' ? 'row' : 'column',
                }}
            >
                {React.Children.map(children, (child, idx) => {
                    if (!child) {
                        return null;
                    }

                    // if (child.type.displayName === 'Tooltip') {
                    //     return (
                    //         <div key={idx} style={groupItemStyles}>
                    //             {appearance ?
                    //                 React.cloneElement(child.props.children as JSX.Element, {
                    //                     appearance,
                    //                     onlyIcon,
                    //                     spacing,
                    //                     isTransparent,
                    //                     isDisabled,
                    //                 }) :
                    //                 child}
                    //         </div>
                    //     );
                    // }

                    return (
                        <div key={idx} style={groupItemStyles}>
                            {appearance ?
                                React.cloneElement(child as JSX.Element, {
                                    appearance,
                                    onlyIcon,
                                    spacing,
                                    isTransparent,
                                    isDisabled,
                                }) :
                                child}
                        </div>
                    );
                })}
                {
                    showSeparator && (
                        <div className={classNames(styles.button__group_separator, styles[`button__group_separator__${layout}`])}/>
                    )
                }
            </div>
        );
    }
}
